conferenceClient.service('vertoService', [
    '$rootScope',
    'logService',
    '$window',
    '$q',
    '$timeout',
    '$interval',
    'attendeeService',
    'config',
    'storageService',
    'helperService',
    'socketService',
    'analyticsWrapperService',
    'connectivityService',
    'automationService',
    'phoneConferenceService',
    'meetingService',
    'localStreamManagerService',
    'avDeviceService',
    'localizationService',
    function (
        $rootScope,
        logService,
        $window,
        $q,
        $timeout,
        $interval,
        attendeeService,
        config,
        storageService,
        helperService,
        socketService,
        analyticsWrapperService,
        connectivityService,
        automationService,
        phoneConferenceService,
        meetingService,
        localStreamManagerService,
        avDeviceService,
        localizationService
    ) {
        const logger = new LogServiceWrapper(logService, 'vertoService');

        var hangupRequested = false,
            socketDisconnectRequested = false,
            curCallType,
            curCallUser,
            phoneConfID,
            verto,
            peerConnection,
            lastCallError = null,
            currentCallReference = null,
            iceRestartTimeout = null,
            //TODO: Mobile should just use devicePermissions instead of having separate mobilePermissions
            mobilePermissions = {
                audioAllowed: false,
                videoAllowed: false
            },
            //ScreenShare
            screenshare_call,
            screenShareStopRequested = false,
            screenShareGetStatsInterval,
            screenShareTCPFailed = false,
            //HD ScreenShare
            hdScreenShareConfgetStatsInterval,
            hdScreenShareVerto,
            hd_screenshare_call,
            hdScreenShareFeedVisible = false,
            hdScreenShareCallStopRequested = false,
            hdScreenShareCallStatsIntervalCount = 0,
            hdScreenShareCallRetryAttempts = 0,
            //Webinar Attendees
            edgeServer = helperService.getEnvironmentCDNUrl(),
            edgeServerHeartbeat = null,
            originConfUUID = '',
            disconnectRetry = 0,
            wsLoggedIn = false,
            windowUnloading = false,
            bwUp = -1,
            bwDown = -1,
            inCall = false,
            failedCallCount = 0,
            iceConnectionAttempts = 0,
            validLine = RegExp.prototype.test.bind(/^([a-z])=(.*)/),
            loggedSDP = false,
            needToSubmitBandwidthResult = true,
            maximumFreeswitchUploadBandwith = 1024,
            lowUploadBandwidthDefault = 100,
            iceServers = [],
            isVertoFeedVisible = false,
            hangupBeforeActiveState = false,
            speedTestInterval = null,
            firstPLStateCalculated = false,
            getStatsInterval;

        var service = {
            call: call,
            callAudioOnly: callAudioOnly,
            callVideoOnly: callVideoOnly,
            callNoMicNoCam: callNoMicNoCam,
            hangup: hangup,
            init: init,
            isInitiated: isInitiated,
            connectFSSocket: connectFSSocket,
            disconnectFSSocket: disconnectFSSocket,
            getFSSocket: getFSSocket,
            getSocketState: getSocketState,
            getVertoAudioParams: getVertoAudioParams,
            checkNodeSocketConnection: checkNodeSocketConnection,
            initMobileOutput: initMobileOutput,
            cleanUpWebSocket: cleanUpWebSocket,
            setCurrentCallReference: setCurrentCallReference,
            logLastStateOfCall: logLastStateOfCall,
            updateStoredDeviceId: updateStoredDeviceId,
            abortCurrentGetUserMediaRequest: abortCurrentGetUserMediaRequest,
            sendIceConnStateToServer: sendIceConnStateToServer,

            getVerto: getVerto,
            getCurCall: getCurCall,
            onHangUpVerto: onHangUpVerto,
            initIceRestart: initIceRestart,
            initIceRestartTimeout: initIceRestartTimeout,
            cancelIceRestartTimeout: cancelIceRestartTimeout,
            attemptReconnection: attemptReconnection,

            //TODO: Create separate service for Edge Server socket/calls
            useEdgeServer: useEdgeServer,
            isEdgeServerEnabled: isEdgeServerEnabled,
            startEdgeServerHeartbeat: startEdgeServerHeartbeat,
            stopEdgeServerHeartbeat: stopEdgeServerHeartbeat,
            setOriginConfUUID: setOriginConfUUID,
            getOriginConfUUID: getOriginConfUUID,

            getStatsCallback: getStatsCallback,

            //ScreenShare
            startScreenShare: startScreenShare,
            stopScreenShare: stopScreenShare,
            forceScreenShareCleanUp: forceScreenShareCleanUp,
            onScreenShareInactive: onScreenShareInactive,
            initScreenShareInactiveCheck: initScreenShareInactiveCheck,
            getScreenShareCall: getScreenShareCall,
            isScreenShareCallConnected: isScreenShareCallConnected,
            getScreenShareResolution: getScreenShareResolution,
            getScreenShareType: getScreenShareType,
            getScreenShareLocalFeed: getScreenShareLocalFeed,
            getScreenShareStream: getScreenShareStream,
            applyScreenShareGetStats: applyScreenShareGetStats,
            screenShareGetStatsCallback: screenShareGetStatsCallback,
            setScreenShareTCPFailed: setScreenShareTCPFailed,
            onScreenShareIceConnectionStateChange: onScreenShareIceConnectionStateChange,

            //HD ScreenShare Conference
            //TODO: Create separate service for HD ScreenShare functions?
            connectHDScreenShareFSSocket: connectHDScreenShareFSSocket,
            disconnectHDScreenShareFSSocket: disconnectHDScreenShareFSSocket,
            callHDScreenShareConference: callHDScreenShareConference,
            hangupHDScreenShareCall: hangupHDScreenShareCall,
            isHDScreenShareCallConnected: isHDScreenShareCallConnected,
            syncRtcHDScreenShareVideo: syncRtcHDScreenShareVideo,
            setHDScreenShareFeedVisible: setHDScreenShareFeedVisible,
            onScreenShareEnded: onScreenShareEnded,
            setHDScreenShareSocket: setHDScreenShareSocket,
            getHDScreenShareSocket: getHDScreenShareSocket,
            setHDScreenShareCall: setHDScreenShareCall,
            getHDScreenShareCall: getHDScreenShareCall,
            setHDScreenShareCallVideoBlind: setHDScreenShareCallVideoBlind,
            applyHDScreenShareConfGetStats: applyHDScreenShareConfGetStats,
            incrementHDScreenShareCallRetryAttempts: incrementHDScreenShareCallRetryAttempts,
            resetHDScreenShareCallRetryAttempts: resetHDScreenShareCallRetryAttempts,
            getHDScreenShareCallRetryAttempts: getHDScreenShareCallRetryAttempts,
            isHDScreenShareAllowed: isHDScreenShareAllowed,
            resetHDScreenShareSrc: resetHDScreenShareSrc,

            runSpeedTest: runSpeedTest,
            _logBandwidth: _logBandwidth,

            retryCall: retryCall,
            onIceConnectionStateChange: onIceConnectionStateChange,
            getIceConnectionState: getIceConnectionState,
            initIceConnectionEventListener: initIceConnectionEventListener,
            getIceServers: getIceServers,

            //TODO: should be local functions ... may be exposed for testing??
            syncRtcLocalStreamAudio: syncRtcLocalStreamAudio,
            syncRtcLocalStreamVideo: syncRtcLocalStreamVideo,
            syncRtcRemoteStreamVideo: syncRtcRemoteStreamVideo,
            getRTCLocalStream: getRTCLocalStream,
            getRTCRemoteStream: getRTCRemoteStream,
            updateLocalTrack: updateLocalTrack,

            //Setting new input/output devices
            setNewAudioInputSource: setNewAudioInputSource,
            setNewVideoInputSource: setNewVideoInputSource,
            setNewAudioOutputSource: setNewAudioOutputSource,
            clearAudioOutputSource: clearAudioOutputSource,

            //Verto Callbacks
            _onDialogState: _onDialogState,
            _onWSLogin: _onWSLogin,
            _onWSClose: _onWSClose,
            _onGranted: _onGranted,
            _onDenied: _onDenied,

            isVertoSocketConnected: isVertoSocketConnected,

            getCurrentCallType: getCurrentCallType,
            setCurrentCallType: setCurrentCallType,

            isInCall: isInCall,
            setIsInCall: setIsInCall,

            getLastCallError: getLastCallError,

            initialSpeedTest: initialSpeedTest,
            setNeedToSubmitBandwidthResult: setNeedToSubmitBandwidthResult,
            onIceServersReceived: onIceServersReceived,
            onFSConnectionComplete: onFSConnectionComplete,
            setPeerConnection: setPeerConnection,

            getMaximumUploadBandwidthForAttendee: getMaximumUploadBandwidthForAttendee,
            getMaxUploadBandwidth: getMaxUploadBandwidth,
            getAttendeeUploadBandwidth: getAttendeeUploadBandwidth,
            getAttendeeDownloadBandwidth: getAttendeeDownloadBandwidth,
            sendBWStateToServer: sendBWStateToServer,

            //function to mute/unmute localstream's audio
            //this will disable outgoing audio from going to freeswitch
            //without changing state in client/server
            //this is so we can mute the audio when a person goes into
            //audio and video option to change mic and test mic
            muteLocalOutgoingAudio: muteLocalOutgoingAudio,
            unmuteLocalOutgoingAudio: unmuteLocalOutgoingAudio,

            setCurrentCaller: setCurrentCaller,
            getCurrentCaller: getCurrentCaller,

            setMobilePermissions: setMobilePermissions,
            getMobilePermissions: getMobilePermissions,

            _onUpdateLocalAudioState: _onUpdateLocalAudioState,
            _onUpdateLocalVideoState: _onUpdateLocalVideoState,
            _onVFITriggered: _onVFITriggered,

            setIsVertoFeedVisible: setIsVertoFeedVisible,
            getIsVertoFeedVisible: getIsVertoFeedVisible,
            onPhoneStateUpdated: onPhoneStateUpdated,

            updateLocalVideoBandwidth: updateLocalVideoBandwidth,
            getLocalVideoBandwidthMax: getLocalVideoBandwidthMax
        };

        $rootScope.$on('update-local-audio-state', service._onUpdateLocalAudioState);
        $rootScope.$on('update-local-video-state', service._onUpdateLocalVideoState);
        $rootScope.$on('ice-servers', service.onIceServersReceived);
        $rootScope.$on('fs-connection-complete', service.onFSConnectionComplete);
        $rootScope.$on('vfi-triggered', service._onVFITriggered);
        $rootScope.$on('screenshare-ended', service.onScreenShareEnded);
        $rootScope.$on('hang-up-verto', service.onHangUpVerto);
        $rootScope.$on('phone-state-updated', service.onPhoneStateUpdated);

        return service;

        ////////////////////////

        function onScreenShareEnded() {
            service.hangupHDScreenShareCall(true);
            service.disconnectHDScreenShareFSSocket();
        }

        function connectHDScreenShareFSSocket() {
            var deferred = $q.defer();

            if (service.getSocketState(service.getHDScreenShareSocket()) === 'connected') {
                //Return if socket already connected
                deferred.resolve();
                return deferred.promise;
            }

            var phoneInfo = phoneConferenceService.getPhoneData();

            logService.log('hdScreenShareVerto Socket Connection Attempt');
            analyticsWrapperService.eventTrack('meeting - verto - HD ScreenShare Verto Socket Connection Attempt');

            var sessid = helperService.generateGUID(attendeeService.getAttendantLoginId());
            logService.log('hdScreenShareVerto sessid:', sessid);

            var newVerto = new $.verto(
                {
                    socketUrl:
                        'wss://' +
                        phoneInfo.server +
                        ':' +
                        phoneInfo.port +
                        (meetingService.getIsSfuEnabled() ? '/8081' : ''),
                    tag: 'hdScreenShareFeed',
                    login: phoneInfo.sipURI,
                    passwd: 'firebird',
                    sessid: sessid,
                    videoParams: {
                        maxHeight: 720,
                        maxWidth: 1280,
                        minFrameRate: 15,
                        minAspectRatio: 1.78
                    },
                    audioParams: service.getVertoAudioParams(),
                    iceServers: service.getIceServers()
                },
                {
                    onDialogState: onDialogState,
                    onWSLogin: onWSLogin,
                    onWSClose: onWSClose,
                    onReportError: onReportError
                }
            );

            service.setHDScreenShareSocket(newVerto);

            function onDialogState(d) {
                var lastState = d.lastState.name;
                curState = d.state.name;
                cause = d.cause;

                if (!d.screenShare) {
                    if (curState === 'recovering') {
                        //When HD Screenshare calls enter 'recovering' state,
                        //They never actually become active...
                        //So in this path, we hang up the call, kick the hung member from FS,
                        //and start a new call
                        service.hangupHDScreenShareCall(true);

                        socketService.send({
                            message: 'kick-from-hd-screenshare-conf',
                            data: {
                                hdScreenShareConfMemberId: attendeeService.getHDScreenShareConfMemberId()
                            },
                            callback: function () {
                                attendeeService.setHDScreenShareConfMemberId(0);
                                service.callHDScreenShareConference();
                                $rootScope.$broadcast('hd-screenshare-conf-call-connecting');
                            }
                        });
                    }

                    if (curState === 'active') {
                        logService.log('HD ScreenShare Started');
                        $rootScope.$broadcast('hd-screenshare-conf-call-connected');
                        service.resetHDScreenShareCallRetryAttempts();

                        if (d.rtc && d.rtc.peer && d.rtc.peer.peer) {
                            service.applyHDScreenShareConfGetStats(d.rtc.peer.peer);
                            d.rtc.peer.peer.oniceconnectionstatechange = onIceConnectionStateChange;
                        }
                    }

                    if (curState === 'destroy') {
                        logService.log('HD ScreenShare Ended');

                        service.resetHDScreenShareSrc();

                        if (!hdScreenShareCallStopRequested) {
                            logService.log('HD ScreenShare call unrequested disconnect');
                            analyticsWrapperService.eventTrack(
                                'meeting - verto - HD ScreenShare conference call unrequested disconnect'
                            );

                            service.logLastStateOfCall(connectivityService.callMediaTypes.HD_SCREENSHARE);
                        } else {
                            analyticsWrapperService.eventTrack(
                                'meeting - verto - HD ScreenShare conference call disconnected'
                            );
                            attendeeService.setHDScreenShareConfMemberId(0);
                        }

                        hdScreenShareCallStopRequested = false;
                        $rootScope.$broadcast('hd-screenshare-conf-call-disconnected');
                    }
                }
            }

            function onWSLogin() {
                logService.log('hdScreenShareVerto Socket Connected');
                analyticsWrapperService.eventTrack('meeting - verto - HD ScreenShare Verto Socket Connected');
                deferred.resolve();
            }

            function onWSClose() {
                logService.log('hdScreenShareVerto Socket Disconnected');
                analyticsWrapperService.eventTrack('meeting - verto - HD ScreenShare Verto Socket Disconnected');
            }

            function onReportError(error) {
                logger.error('onReportError', 'hdScreenShareVerto Error', error);
                analyticsWrapperService.eventTrack('meeting - verto - HD ScreenShare Verto Error', {
                    category: 'verto'
                });
            }

            function onIceConnectionStateChange() {
                var hdPeerConnection;
                var iceConnectionState;

                try {
                    hdPeerConnection = service.getHDScreenShareCall().rtc.peer.peer;
                    iceConnectionState = hdPeerConnection.iceConnectionState;
                } catch (e) {
                    iceConnectionState = 'unknown';
                }

                logService.log('HD ScreenShare Conf Call iceConnectionState:', iceConnectionState);
                analyticsWrapperService.eventTrack(
                    'Meeting - HD ScreenShare iceConnectionState - ' + iceConnectionState,
                    {
                        category: 'verto'
                    }
                );

                //Currently only handling failed state, but leaving
                //all other conditions in case we need to handle them in the future
                switch (iceConnectionState) {
                    case 'new':
                        break;
                    case 'checking':
                        break;
                    case 'failed':
                        if (hdPeerConnection) {
                            hdPeerConnection.oniceconnectionstatechange = null;
                        }

                        service.hangupHDScreenShareCall();

                        //Retry up to three times... after three, just leave the call hung up
                        if (service.getHDScreenShareCallRetryAttempts() <= 3) {
                            logService.log('HD ScreenShare Conf Call failed... retrying...');
                            service.incrementHDScreenShareCallRetryAttempts();
                            service.callHDScreenShareConference();
                        } else {
                            logService.log('HD ScreenShare Conf Call failed after 3 attempts');
                        }

                        break;
                    case 'disconnected':
                        break;
                    case 'connected':
                    case 'completed':
                        service.syncRtcHDScreenShareVideo();
                        break;
                    case 'closed':
                        break;
                }
            }

            return deferred.promise;
        }

        function disconnectHDScreenShareFSSocket() {
            var socket = service.getHDScreenShareSocket();

            if (socket) {
                logService.log('Disconnecting hdScreenShareVerto socket');
                socket.logout();
                delete socket.callbacks;
                service.setHDScreenShareSocket(null);
            }
        }

        function callHDScreenShareConference() {
            logService.log('Calling into HD ScreenShare conference');
            analyticsWrapperService.eventTrack('meeting - verto - HD ScreenShare conference call attempt');

            var phoneInfo = phoneConferenceService.getPhoneData();
            var phoneConfID = phoneInfo.phoneConferenceUserID;
            var bandWithToUse = service.getMaxUploadBandwidth();

            if (service.getSocketState(service.getHDScreenShareSocket()) === 'connected') {
                makeCall();
            } else {
                service.connectHDScreenShareFSSocket().then(makeCall);
            }

            function makeCall() {
                var newCall = hdScreenShareVerto.newCall({
                    destination_number: '44_firebird_' + phoneConfID,
                    caller_id_name: curCallUser.callerID,
                    caller_id_number: curCallUser.callerID,
                    outgoingBandwidth: bandWithToUse,
                    useVideo: true,
                    useCamera: 'none',
                    useMic: 'none',
                    useSpeak: 'none',
                    screenShare: false
                });

                service.setHDScreenShareCall(newCall);
            }
        }

        function hangupHDScreenShareCall(requested) {
            var call = service.getHDScreenShareCall();

            if (requested) {
                hdScreenShareCallStopRequested = true;
            }

            if (call) {
                logService.log('Hanging up call to HD Screenshare Conference');
                call.hangup();
            }
        }

        function setHDScreenShareSocket(newVerto) {
            hdScreenShareVerto = newVerto;
        }

        function getHDScreenShareSocket() {
            return hdScreenShareVerto;
        }

        function setHDScreenShareCall(newCall) {
            hd_screenshare_call = newCall;
        }

        function getHDScreenShareCall() {
            return hd_screenshare_call;
        }

        function setHDScreenShareCallVideoBlind(blind) {
            if (!service.isHDScreenShareCallConnected()) {
                return;
            }

            logService.log('Toggling HD ScreenShare call video blind to:', blind);
            socketService.send({
                message: 'hd-screenshare-call-video-blind',
                data: { blind: blind }
            });
        }

        function getSocketState(socket) {
            var readyState;
            var returnState;

            try {
                readyState = socket.rpcClient._ws_socket.readyState;
            } catch (e) {}

            switch (readyState) {
                case 0: //Connecting
                    returnState = 'connecting';
                    break;
                case 1: //Connected
                    returnState = 'connected';
                    break;
                case 2: //Closing
                    returnState = 'closing';
                    break;
                case 3: //Closed
                    returnState = 'closed';
                    break;
                default:
                    returnState = 'unknown';
                    break;
            }

            return returnState;
        }

        function incrementHDScreenShareCallRetryAttempts() {
            hdScreenShareCallRetryAttempts++;
        }

        function resetHDScreenShareCallRetryAttempts() {
            hdScreenShareCallRetryAttempts = 0;
        }

        function getHDScreenShareCallRetryAttempts() {
            return hdScreenShareCallRetryAttempts;
        }

        function isHDScreenShareCallConnected() {
            var call = service.getHDScreenShareCall();
            return call && call.state && call.state.name === 'active';
        }

        function isInCall() {
            return inCall;
        }

        function setIsInCall(incall) {
            inCall = incall;
        }

        function getLastCallError() {
            return lastCallError;
        }

        function isVertoSocketConnected() {
            return wsLoggedIn;
        }

        function getVerto() {
            return verto;
        }

        function getCurCall() {
            var curCall;

            try {
                var vertoObj = service.getVerto();
                if (vertoObj) {
                    var dialogs = vertoObj.dialogs;
                    curCall = dialogs[Object.keys(dialogs)[0]];
                }
            } catch (e) {
                logService.log('Error retrieving curCall:', e);
            }

            if (curCall === undefined) {
                curCall = null;
            }

            return curCall;
        }

        function getCurrentCallType() {
            return curCallType;
        }

        function setCurrentCallType(newCallType) {
            curCallType = newCallType;
        }

        function init(phoneInfo, newIceServers) {
            phoneConfID = phoneInfo.phoneConferenceUserID;

            if (!helperService.browserHasWebRTC()) {
                return;
            }

            $.verto.init(
                {
                    skipPermCheck: true,
                    skipDeviceCheck: true
                },
                function () {}
            );

            iceServers = newIceServers || [];
            iceServers.unshift({ urls: 'stun:stun.l.google.com:19302' });
            logService.log('initial ice servers:', iceServers);
        }

        function connectFSSocket() {
            var deferred = $q.defer();

            if (service.getSocketState(service.getFSSocket()) === 'connected') {
                //Return if socket already connected
                deferred.resolve();
                return deferred.promise;
            }

            var phoneInfo = phoneConferenceService.getPhoneData();

            //Freeswitch Socket connects when $.verto() is called
            analyticsWrapperService.eventTrack('meeting - verto - freeswitch socket connection attempt', {
                category: 'verto'
            });

            var server = service.useEdgeServer() ? edgeServer : phoneInfo.server;
            logService.log('Using FS server:', server);

            var deviceParams = {};

            if (service.useEdgeServer()) {
                deviceParams.useCamera = false;
                deviceParams.useMic = 'none';
            }

            var sessid = helperService.generateGUID(attendeeService.getAttendantLoginId());
            logService.log('verto sessid:', sessid);

            verto = new $.verto(
                {
                    socketUrl:
                        'wss://' + server + ':' + phoneInfo.port + (meetingService.getIsSfuEnabled() ? '/8081' : ''),
                    tag: 'videoFeed',
                    audioHackTag: 'audioFeed',
                    login: phoneInfo.sipURI,
                    passwd: 'firebird',
                    sessid: sessid,
                    deviceParams: deviceParams,
                    videoParams: {
                        maxHeight: 720,
                        maxWidth: 1280,
                        minFrameRate: 15,
                        minAspectRatio: 1.78
                    },
                    audioParams: service.getVertoAudioParams(),
                    iceServers: iceServers,
                    permissionCallback: {
                        onGranted: service._onGranted,
                        onDenied: service._onDenied
                    }
                },
                {
                    onDialogState: service._onDialogState,
                    onWSLogin: onWSLogin,
                    onWSClose: service._onWSClose,
                    onReportError: onReportError
                }
            );

            //Using this as a middle man
            function onWSLogin() {
                service._onWSLogin();
                deferred.resolve();
            }

            function onReportError(error) {
                logger.error('onReportError', 'Verto Error', error);
                analyticsWrapperService.eventTrack('meeting - verto - freeswitch socket error', {
                    category: 'verto'
                });
            }

            //When connecting Verto socket, set attendee state to 'connecting'
            sendIceConnStateToServer('connecting');

            return deferred.promise;
        }

        function disconnectFSSocket() {
            var socket = service.getFSSocket();

            if (socket && service.getSocketState(socket) === 'connected') {
                logService.log('Disconnecting verto socket');
                socketDisconnectRequested = true;
                //on iOS, calling socket.logout causes
                //mobile user to not be removed from attendee list immediately
                //in previous mobile clients logout call did not happen so removing
                //the call on ios
                if (helperService.getDevicePlatform() !== 'iOS') {
                    socket.logout();
                }
                delete socket.callbacks;
                verto = null;
            }
        }

        function getFSSocket() {
            return verto;
        }

        function getVertoAudioParams() {
            var audioParams;

            if (helperService.isChrome() || helperService.isElectron()) {
                audioParams = {
                    googEchoCancellation: true,
                    googEchoCancellation2: true,
                    // googDAEchoCancellation : audioParams.googDAEchoCancellation,
                    googAutoGainControl2: true,
                    googAutoGainControl: true,
                    googNoiseSuppression: true,
                    googNoiseSuppression2: true,
                    googHighpassFilter: true
                    // // googTypingNoiseDetection : audioParams.googTypingNoiseDetection,
                };
            } else {
                audioParams = {
                    echoCancellation: true,
                    mozNoiseSuppression: true,
                    mozAutoGainControl: true
                };
            }

            return audioParams;
        }

        function isInitiated() {
            return verto !== null && verto !== undefined;
        }

        function getMaxUploadBandwidth() {
            return maximumFreeswitchUploadBandwith;
        }

        function getAttendeeUploadBandwidth() {
            return bwUp;
        }

        function getAttendeeDownloadBandwidth() {
            return bwDown;
        }

        function getMaximumUploadBandwidthForAttendee(uploadBandwidth, maxUploadBandwidth) {
            var bandWithToUse = maxUploadBandwidth;

            if (uploadBandwidth < maxUploadBandwidth * 1.25) {
                bandWithToUse = uploadBandwidth * 0.8;
            }
            return bandWithToUse;
        }

        function startVertoCall(callType, user) {
            if (inCall) {
                return;
            }
            lastCallError = null;
            inCall = true;

            service.setCurrentCallType(callType);
            service.setCurrentCaller(user);

            var confType = 1;
            var isWebinar = meetingService.getMeetingType() === 'webinar';

            if (isWebinar) {
                confType = user.isHost || user.isPresenter ? 1 : 7;
            }

            var phoneInfo = phoneConferenceService.getPhoneData();
            var originServer = phoneInfo.server;
            var dest = confType + '_firebird_' + phoneConfID;

            var platform = getCurrentPlatform();
            var bandWithToUse = service.getMaxUploadBandwidth();

            // var isDeaf = (connectivityService.getAudioThroughPhone() && !isWebinar) ? true : false;
            var isDeaf = false;

            var callInfo = {
                destination_number: dest,
                caller_id_name: user.name,
                caller_id_number: user.callerID,
                useVideo: true,
                useStereo: false,
                outgoingBandwidth: bandWithToUse,
                userVariables: {
                    device_platform: platform,
                    attendant_login_id: '' + user.attendantLoginId, //user variable must be string
                    is_vmuted: '' + (user.isVideoMuted ? true : false),
                    is_amuted: '' + (user.isAudioMuted ? true : false),
                    is_deaf: '' + isDeaf,
                    is_webinar: '' + isWebinar,
                    origin_server: '' + originServer,
                    localVideoURLDelay: helperService.getDevicePlatform() === 'iOS' ? 1000 : 0
                }
            };

            if (service.useEdgeServer()) {
                callInfo.userVariables.origin_conf_uuid = service.getOriginConfUUID() + '';
            }

            automationService.getAudioState().vertoCallParameters = callInfo;

            var videoDevice = storageService.get('video-device');
            var audioDevice = storageService.get('audio-device');
            var audioOutputDevice = storageService.get('audio-output-device');

            //Set default output device for webinar attendees
            if (isWebinar && !user.isHost && !user.isPresenter) {
                audioOutputDevice = 'any';
            }
            callInfo.useSpeak = audioOutputDevice === null ? 'any' : audioOutputDevice;

            switch (callType) {
                case 'audioAndVideo':
                    logService.log('audioAndVideo call with video device:', videoDevice);
                    verto.videoParams(localStreamManagerService.getIdealVideoConstraints());

                    avDeviceService.setDeviceErrors({
                        camError: false,
                        micError: false
                    });

                    callInfo.useCamera = videoDevice === null ? 'any' : videoDevice;
                    callInfo.useMic = audioDevice === null ? 'any' : audioDevice;

                    break;

                case 'audioOnly':
                    avDeviceService.setDeviceErrors({
                        micError: false
                    });

                    callInfo.useCamera = 'none';
                    callInfo.useMic = user.isViewerOnly ? 'none' : audioDevice === null ? 'any' : audioDevice;

                    break;

                case 'videoOnly':
                    avDeviceService.setDeviceErrors({
                        camError: false
                    });

                    logService.log('videoOnly call with video device:', videoDevice);
                    verto.videoParams(localStreamManagerService.getIdealVideoConstraints());

                    callInfo.useCamera = user.isViewerOnly ? 'none' : videoDevice === null ? 'any' : videoDevice;
                    callInfo.useMic = 'none';

                    break;

                case 'noMicNoCam':
                    callInfo.useCamera = 'none';
                    callInfo.useMic = 'none';

                    break;

                default:
                    avDeviceService.setDeviceErrors({
                        camError: false,
                        micError: false
                    });

                    //audioAndVideo by default
                    callInfo.useCamera = videoDevice === null ? 'any' : videoDevice;
                    callInfo.useMic = audioDevice === null ? 'any' : audioDevice;

                    break;
            }

            service.updateStoredDeviceId('mic', callInfo.useMic);
            service.updateStoredDeviceId('cam', callInfo.useCamera);
            service.updateStoredDeviceId('speaker', callInfo.useSpeak);

            if (service.getSocketState(service.getFSSocket()) === 'connected') {
                analyticsWrapperService.eventTrack(
                    'meeting - verto - checking Node Socket connection before making Verto call'
                );
                service.checkNodeSocketConnection(makeCall);
            } else {
                service
                    .connectFSSocket() //will automatically return if already connected
                    .then(function () {
                        analyticsWrapperService.eventTrack(
                            'meeting - verto - checking Node Socket connection before making Verto call'
                        );
                        service.checkNodeSocketConnection(makeCall);
                    })
                    .catch(function (err) {
                        logger.error(
                            'startVertoCall',
                            'Error checking fss or node socket connection before Verto call',
                            err
                        );
                    });
            }

            function makeCall() {
                //If a Verto dialog already exists when making a new call,
                //Check to make sure that dialog isn't active or becoming active...
                //If it is, prevent new call from being
                if (verto.dialogs && Object.keys(verto.dialogs).length > 0) {
                    var dialogKeys = Object.keys(verto.dialogs);

                    for (var i = 0; i < dialogKeys.length; i++) {
                        var curKey = dialogKeys[i];

                        if (verto.dialogs[curKey] && verto.dialogs[curKey].state) {
                            if (
                                verto.dialogs[curKey].state.name !== 'destroy' &&
                                verto.dialogs[curKey].state.name !== 'hangup' &&
                                verto.dialogs[curKey].state.name !== 'purge'
                            ) {
                                logService.log('Active Verto dialog already exists... returning from makeCall');
                                return;
                            }
                        }
                    }
                }

                //Generic Call Event
                analyticsWrapperService.eventTrack('meeting - verto - call attempt', {
                    category: 'verto'
                });

                //Specific Call Type
                analyticsWrapperService.eventTrack('meeting - verto - starting call with ' + callType, {
                    category: 'verto'
                });

                if (callType !== 'noMicNoCam') {
                    //This helps us track Verto calls that require getUserMedia (micAndWebcam, micOnly, and videoOnly)
                    analyticsWrapperService.eventTrack('meeting - verto - starting call with media', {
                        category: 'verto'
                    });
                }

                var curCallRef = verto.newCall(callInfo);
                service.setCurrentCallReference(curCallRef);
                sendIceConnStateToServer('connecting');

                //TODO: we probably need to always broadcast this and have conference controller decide whether
                //      to start the overlay or not
                if (callType !== 'noMicNoCam') {
                    $rootScope.$broadcast('verto-call-started');
                }
            }
        }

        function updateStoredDeviceId(deviceType, deviceId) {
            //In the case of a FS socket disconnect, Verto automatically
            //disconnects/reconnects a FS call... it uses options.audioParams or options.videoParams
            //for its default a/v settings, so we need to update it with whichever
            //a/v device the user has selected
            if (verto && verto.options) {
                if (verto.options.audioParams && deviceType === 'mic') {
                    logService.log('Updating verto options mic deviceId to: ' + deviceId);
                    verto.options.audioParams.deviceId = deviceId;
                }

                if (verto.options.deviceParams && deviceType === 'cam') {
                    logService.log('Updating verto options webcam deviceId to: ' + deviceId);
                    verto.options.deviceParams.useCamera = deviceId;
                }

                if (verto.options.deviceParams && deviceType === 'speaker') {
                    logService.log('Updating verto options speaker deviceId to: ' + deviceId);
                    verto.options.deviceParams.useSpeak = deviceId;
                }
            }
        }

        function abortCurrentGetUserMediaRequest() {
            var curCall = service.getCurCall();
            if (curCall && curCall.rtc) {
                curCall.rtc.abortGetUserMediaRequest = true;
            }
        }

        function setCurrentCallReference(newCurrentCallReference) {
            currentCallReference = newCurrentCallReference;
        }

        function checkNodeSocketConnection(cb) {
            if (connectivityService.getServerInitiatedDisconnect()) {
                return;
            }

            var connectedMsg = 'Node Socket connected before making Verto call';
            var notConnectedMsg = 'Node Socket not connected before making Verto call, checking again after 1 second';

            if (socketService.isConnected()) {
                logService.log(connectedMsg);
                analyticsWrapperService.eventTrack('meeting - verto - ' + connectedMsg);
                cb();
            } else {
                logService.log(notConnectedMsg);
                $timeout(function () {
                    service.checkNodeSocketConnection(cb);
                }, 1000);
            }
        }

        function call(user) {
            if (!helperService.browserHasWebRTC()) {
                logger.error('call', 'webrtc is not supported');
                return;
            }

            startVertoCall('audioAndVideo', user);
        }

        function callAudioOnly(user) {
            if (!helperService.browserHasWebRTC()) {
                logger.error('callAudioOnly', 'webrtc is not supported');
                return;
            }

            startVertoCall('audioOnly', user);
        }

        function callVideoOnly(user) {
            if (!helperService.browserHasWebRTC()) {
                logger.error('callVideoOnly', 'webrtc is not supported');
                return;
            }

            startVertoCall('videoOnly', user);
        }

        function callNoMicNoCam(user) {
            if (!helperService.browserHasWebRTC()) {
                logger.error('callNoMicNoCam', 'webrtc is not supported');
                return;
            }

            if (service.useEdgeServer()) {
                logService.log('attempting to connect to cdn server in webinar: ' + meetingService.getMeetingCode());
            }

            startVertoCall('noMicNoCam', user);
        }

        function hangup(intentional) {
            if (!helperService.browserHasWebRTC()) {
                logger.error('hangup', 'webrtc is not supported');
                return;
            }

            if (!inCall) {
                return;
            }

            inCall = false;

            if (intentional) {
                hangupRequested = true;
            }

            analyticsWrapperService.eventTrack('meeting - verto - hanging up call', {
                category: 'verto'
            });

            localStreamManagerService.stopLocalVideoTrack();

            verto.hangup();
            service.setCurrentCallReference(null);

            service.cleanUpWebSocket();

            if (!helperService.getIsMeetingEnding()) {
                avDeviceService.setDevicePermissions({
                    audioAllowed: false,
                    videoAllowed: false
                });
            }

            if (service.isEdgeServerEnabled()) {
                service.stopEdgeServerHeartbeat();
            }

            stopGetStatsInterval();
            stopScreenShareGetStatsInterval();
            stopHDScreenShareConfGetStatsInterval();
        }

        function startScreenShare(user) {
            if (!helperService.browserHasWebRTC()) {
                logger.error('startScreenShare', 'webrtc is not supported');
                return;
            }

            if (user.videoParams) {
                var screenshareFrameRate = 5;

                user.videoParams.minFrameRate = screenshareFrameRate;
                user.videoParams.maxFrameRate = screenshareFrameRate;

                user.videoParams.maxHeight = 1080;
                user.videoParams.maxWidth = 1920;
            }

            analyticsWrapperService.eventTrack('meeting - verto - start screen share', {
                category: 'verto'
            });

            var bandWithToUse = service.getMaxUploadBandwidth();

            //Hack alert: We always have a stun server.  if there are no more servers, we don't have turn servers.
            //This needs to be treated like TCP screen sharing failed
            //console.log(iceServers, service.iceServers);
            if (iceServers.length <= 1) {
                service.setScreenShareTCPFailed(true);
            }

            var screenShareWidth = $window.screen.width > 1920 ? 1920 : $window.screen.width;
            var screenShareHeight = $window.screen.height > 1080 ? 1080 : $window.screen.height;

            var callParams = {
                destination_number: '33_firebird_' + phoneConfID,
                caller_id_name: user.callerID + '_(Screenshare)',
                caller_id_number: user.callerID + '_(Screenshare)',
                outgoingBandwidth: bandWithToUse,
                videoParams: user.videoParams,
                useVideo: true,
                useMic: 'none',
                useSpeak: 'none',
                screenShare: true,
                vendMaxQuant: 50,
                acceptUDP: screenShareTCPFailed,
                userVariables: {
                    email: screenShareWidth + 'x' + screenShareHeight
                },
                useStream: user.useStream
            };

            screenshare_call = verto.newCall(callParams);
        }

        function stopScreenShare() {
            if (!helperService.browserHasWebRTC()) {
                logger.error('stopScreenShare', 'webrtc is not supported');
                return;
            }

            //Close the Chrome dialog window
            //Make sure this is done before we set screenshare_call to null
            var screenShareStream = service.getScreenShareStream();
            if (screenShareStream) {
                screenShareStream.stop();
            }

            if (screenshare_call) {
                logService.log('Hanging up Screenshare call');
                screenShareStopRequested = true;
                screenshare_call.hangup();

                // TODO sbelikov: do we need to stop here? What about HD?
                stopScreenShareGetStatsInterval();
                // stopHDScreenShareConfGetStatsInterval();
            }

            analyticsWrapperService.eventTrack('meeting - verto - ended screen share', {
                category: 'verto'
            });
        }

        function getRTCLocalStream() {
            var rtcLocalStream = null;

            try {
                rtcLocalStream = service.getCurCall().rtc.localStream;
            } catch (e) {}

            return rtcLocalStream;
        }

        function getRTCRemoteStream() {
            var rtcRemoteStream = null;

            try {
                rtcRemoteStream = service.getCurCall().rtc.peer.peer.getRemoteStreams()[0];
            } catch (e) {}

            return rtcRemoteStream;
        }

        function syncRtcLocalStreamAudio() {
            var rtcLocalStream = service.getRTCLocalStream();

            if (rtcLocalStream && rtcLocalStream.getAudioTracks) {
                var localAudioTracks = rtcLocalStream.getAudioTracks() || [];
                var localTrack = localAudioTracks[0];

                if (localTrack) {
                    var enableLocalAudio =
                        !attendeeService.getIsAudioMuted() && !connectivityService.getAudioThroughPhone();
                    localTrack.enabled = enableLocalAudio;
                }
            }
        }

        function syncRtcLocalStreamVideo() {
            if (!attendeeService.getIsVideoMuted()) {
                service.updateLocalTrack('video');
            }
        }

        function syncRtcRemoteStreamVideo() {
            var rtcRemoteStream = service.getRTCRemoteStream();

            if (rtcRemoteStream && rtcRemoteStream.getVideoTracks) {
                var remoteVideoTracks = rtcRemoteStream.getVideoTracks() || [];
                var remoteTrack = remoteVideoTracks[0];

                if (remoteTrack) {
                    var enableRemoteFeed = service.getIsVertoFeedVisible();

                    attendeeService.setVideoBlind(!enableRemoteFeed, function () {
                        remoteTrack.enabled = enableRemoteFeed;
                    });
                }
            }
        }

        //This function is used primarily for automation
        function getLocalVideoBandwidthMax() {
            logService.log('starting getLocalVideoBandwidthMax ...');

            if (localStreamManagerService.shouldUseDeprecatedSpecForStreams()) {
                return null;
            }

            try {
                if (!service.getCurCall()) {
                    return null;
                }
                var peer = service.getCurCall().rtc.peer.peer;
                var senders = peer.getSenders(); //Should have one sender each for Audio and Video
                var currentSender;

                for (var i = 0; i < senders.length; i++) {
                    if (senders[i] && senders[i].track && senders[i].track.kind === 'video') {
                        currentSender = senders[i];
                        break;
                    }
                }

                if (currentSender && currentSender.setParameters) {
                    var parameters = currentSender.getParameters();
                    if (!parameters.encodings) {
                        return null;
                    }

                    return parameters.encodings[0].maxBitrate;
                }
            } catch (e) {
                logger.error('getLocalVideoBandwidthMax', 'Error', e);
                return null;
            }

            return null;
        }

        function updateLocalVideoBandwidth(newBitrate) {
            logService.log('starting updateLocalVideoBandwidth ', newBitrate);

            if (localStreamManagerService.shouldUseDeprecatedSpecForStreams()) {
                return;
            }

            try {
                if (!service.getCurCall()) {
                    logService.log('No current call, exiting updateLocalVideoBandwidth');
                    return;
                }
                var peer = service.getCurCall().rtc.peer.peer;
                var senders = peer.getSenders(); //Should have one sender each for Audio and Video
                var currentSender;

                for (var i = 0; i < senders.length; i++) {
                    if (senders[i] && senders[i].track && senders[i].track.kind === 'video') {
                        currentSender = senders[i];
                        break;
                    }
                }

                if (currentSender && currentSender.setParameters) {
                    var parameters = currentSender.getParameters();
                    if (!parameters.encodings) {
                        parameters.encodings = [{}];
                    }

                    parameters.encodings[0].maxBitrate = newBitrate;

                    currentSender
                        .setParameters(parameters)
                        .then(function () {
                            logService.log('dynamic bitrate successfully set: ' + newBitrate);
                        })
                        .catch(function (e) {
                            logger.error('updateLocalVideoBandwidth', 'Error setting dynamic bitrate parameters', e);
                        });
                }
            } catch (e) {
                logger.error('updateLocalVideoBandwidth', 'Error', e);
            }
        }

        //Updates local audio or video track based on tracks in localStreamManagerService
        function updateLocalTrack(trackMediaType) {
            if (localStreamManagerService.shouldUseDeprecatedSpecForStreams()) {
                return;
            }

            try {
                var newTrack;

                if (trackMediaType === 'audio') {
                    newTrack = localStreamManagerService.currentLocalAudioTrack;
                } else if (trackMediaType === 'video') {
                    newTrack = localStreamManagerService.currentLocalVideoTrack;
                }

                if (!newTrack) {
                    return;
                }

                if (!service.getCurCall()) {
                    logService.log('vertoService.updateLocalTrack no current call, ignored');
                    return;
                }

                var peer = service.getCurCall().rtc.peer.peer;
                var senders = peer.getSenders(); //Should have one sender each for Audio and Video
                var currentSender;

                for (var i = 0; i < senders.length; i++) {
                    if (senders[i] && senders[i].track && senders[i].track.kind === trackMediaType) {
                        currentSender = senders[i];
                        break;
                    }
                }

                if (currentSender) {
                    var rtcLocalStream = service.getRTCLocalStream();
                    var oldTrack;

                    if (trackMediaType === 'audio') {
                        oldTrack = rtcLocalStream.getAudioTracks()[0];
                    } else if (trackMediaType === 'video') {
                        oldTrack = rtcLocalStream.getVideoTracks()[0];
                    }

                    if (oldTrack && oldTrack.id === newTrack.id) {
                        return;
                    }

                    currentSender
                        .replaceTrack(newTrack)
                        .then(function () {
                            oldTrack.stop();
                            rtcLocalStream.removeTrack(oldTrack);
                            rtcLocalStream.addTrack(newTrack);

                            if (trackMediaType === 'audio') {
                                service.syncRtcLocalStreamAudio();
                            }
                        })
                        .catch(function (err) {
                            logService.log('Unable to update Verto Track:', err);
                        });
                }
            } catch (e) {
                logService.log('vertoService.updateLocalTrack error:', e);
            }
        }

        function setNewAudioInputSource(deviceId, stream) {
            if (localStreamManagerService.shouldUseDeprecatedSpecForStreams()) {
                return;
            }

            logService.log('Setting new Audio Input Source:', deviceId);

            //First update localStreamManager's local track reference
            //Then update Verto's local track reference (which gets the track from localStreamManagerService)

            var localAudioTrack = stream && stream.getAudioTracks ? stream.getAudioTracks()[0] : null;
            if (localAudioTrack) {
                localStreamManagerService.replaceLocalAudioTrack(localAudioTrack);
                stream.removeTrack(localAudioTrack);
            }

            service.updateLocalTrack('audio');
            service.updateStoredDeviceId('mic', deviceId);

            $rootScope.$broadcast('verto-call-audio-input-updated');
        }

        function setNewVideoInputSource(deviceId, stream) {
            if (localStreamManagerService.shouldUseDeprecatedSpecForStreams()) {
                return;
            }

            logService.log('Setting new Video Input Source:', deviceId);

            //First update localStreamManager's local track reference
            //Then update Verto's local track reference (which gets the track from localStreamManagerService)

            var localVideoTrack = stream && stream.getVideoTracks ? stream.getVideoTracks()[0] : null;
            if (localVideoTrack) {
                localStreamManagerService.replaceLocalVideoTrack(localVideoTrack);
                stream.removeTrack(localVideoTrack);
            }

            service.updateLocalTrack('video');
            service.updateStoredDeviceId('cam', deviceId);

            if (attendeeService.getIsVideoMuted()) {
                localStreamManagerService.stopLocalVideoTrack();
            }
        }

        function setNewAudioOutputSource(deviceId) {
            try {
                logService.log('Setting new Audio Output Source:', deviceId);
                $window.$('#videoFeed')[0].setSinkId(deviceId);
                service.updateStoredDeviceId('speaker', deviceId);
            } catch (err) {
                logService.log('Unable to set sink id:', err);
            }
        }

        function clearAudioOutputSource() {
            try {
                $window.$('#videoFeed')[0].setSinkId('');
            } catch (err) {
                logger.error('clearAudioOutputSource', 'Unable to clear audio output source', err);
            }
        }

        function syncRtcHDScreenShareVideo() {
            var hdRTCRemoteStream;

            try {
                hdRTCRemoteStream = service.getHDScreenShareCall().rtc.remoteStream;
            } catch (e) {}

            if (hdRTCRemoteStream && hdRTCRemoteStream.getVideoTracks) {
                var hdVideoTracks = hdRTCRemoteStream.getVideoTracks() || [];
                var track = hdVideoTracks[0];
                var enableHDFeed = hdScreenShareFeedVisible ? true : false;

                if (track && track.enabled !== enableHDFeed) {
                    track.enabled = enableHDFeed;
                }
            }
        }

        function setHDScreenShareFeedVisible(isHDVisible) {
            if (!service.isHDScreenShareAllowed()) {
                return;
            }

            //Only sync if value changes
            if (hdScreenShareFeedVisible !== isHDVisible || isVertoFeedVisible === isHDVisible) {
                hdScreenShareFeedVisible = isHDVisible;

                if (isHDVisible) {
                    //If switching from non-HD to HD feed:
                    //  1. enable HD track and unvblind first
                    //  2. disable non-HD track and vblind
                    service.setHDScreenShareCallVideoBlind(false);
                    service.syncRtcHDScreenShareVideo();
                    service.setIsVertoFeedVisible(false);
                } else {
                    //If switching from HD to non-HD feed:
                    //  1. enable non-HD track and unvblind first
                    //  2. disable HD track and vblind (with delay)
                    service.setIsVertoFeedVisible(true);
                    $timeout(service.syncRtcHDScreenShareVideo, 1500);
                    service.setHDScreenShareCallVideoBlind(true);
                }
            }
        }

        //TODO: figure out if we're clearing the last call error here or resetting it earlier in the start flow
        function _onGranted() {
            $rootScope.$broadcast('new-explicit-permission-granted');
            $rootScope.$broadcast('change-meeting-content-opacity', false);

            logService.log('get user media request granted');

            analyticsWrapperService.eventTrack('meeting - verto - permission granted', {
                category: 'verto'
            });
        }

        //this is really a device or an error problem ... when the fail call happens
        //we will deal with this
        function _onDenied(dialog, err) {
            var isCatalinaError = false;
            logService.log('_OnDenied called from verto service, ', err);

            lastCallError = err;

            if (dialog && dialog.options && dialog.options.screenShare) {
                if (err && err.message === 'Permission denied by system' && helperService.isChromeOSXCatalina()) {
                    isCatalinaError = true;
                }
            }

            if (isCatalinaError) {
                $rootScope.$broadcast('catalina-ss-security-error');
            } else {
                $rootScope.$broadcast('new-explicit-permission-denied');
            }
        }

        function _onDialogState(d) {
            logService.log('Dialog State:', d);

            var lastState = d.lastState.name;
            curState = d.state.name;
            cause = d.cause;

            if (!d.screenShare) {
                //Regular Calls

                if (curState !== 'destroy' && !loggedSDP) {
                    if (d.rtc && d.rtc.mediaData && d.rtc.mediaData.SDP) {
                        _analyzeLogSDP(d.rtc.mediaData.SDP);
                    }
                }

                if (curState === 'recovering' || lastState === 'recovering') {
                    if (verto && verto.dialogs && Object.keys(verto.dialogs).length > 1) {
                        logService.log(
                            'Verto dialog already exists while previous call is recovering... hanging up recovering call'
                        );
                        verto.hangup(d.callID);
                    }
                }

                //Hangup eventually goes to destroy
                if (curState === 'hangup') {
                    if ((lastState === 'new' || lastState === 'requesting') && !hangupRequested) {
                        hangupBeforeActiveState = true;
                    }
                }

                if (curState === 'destroy') {
                    inCall = false;
                    connectivityService.setVertoConnected(false);
                    connectivityService.setFSMemberConnected(false);
                    connectivityService.resetStunTrackingData(connectivityService.callMediaTypes.VERTO);
                    service.clearAudioOutputSource();

                    //In case call goes to destroyed during ICE Restart attempt...
                    service.cancelIceRestartTimeout();

                    var isPageUnloading = helperService.getIsPageUnloading();
                    var isMeetingEnding = helperService.getIsMeetingEnding();
                    var unrequestedDisconnect = !hangupRequested && !isPageUnloading && !isMeetingEnding;

                    if (unrequestedDisconnect) {
                        $rootScope.$broadcast('verto-call-unrequested-disconnect');

                        analyticsWrapperService.eventTrack('meeting - verto - unrequested disconnected', {
                            category: 'verto'
                        });

                        service.logLastStateOfCall(connectivityService.callMediaTypes.VERTO);

                        if (service.useEdgeServer()) {
                            logger.error('_onDialogState', 'Possible call rejection from cdn server in webinar');
                        }
                    }

                    // Catch-all analytics event for disconnected call
                    analyticsWrapperService.eventTrack('meeting - verto - call destroyed', {
                        category: 'verto'
                    });

                    if (attendeeService.getIsPhonePaired()) {
                        if (unrequestedDisconnect) {
                            //Re-pair after re-connect
                            var phoneMemberId = attendeeService.getPhoneMemberId();
                            attendeeService.setReconnectingPairId(phoneMemberId);
                        }

                        if (!attendeeService.getIsWaitingForPromoteDemote()) {
                            socketService.send({ message: 'unpair-phone-caller' });
                        }
                    }

                    switch (cause) {
                        case 'Device or Permission Error':
                            analyticsWrapperService.eventTrack('meeting - verto - device or permission error', {
                                category: 'verto'
                            });

                            //TODO: remove the device permissions rejected event
                            $rootScope.$broadcast('device-permissions-rejected');
                            $rootScope.$broadcast('verto-call-error');

                            break;

                        case 'NORMAL CLEARING': //Underscore is sometimes there,
                        case 'NORMAL_CLEARING': //so we account for both cases
                            analyticsWrapperService.eventTrack('meeting - verto - call disconnected', {
                                category: 'verto'
                            });

                            if (hangupBeforeActiveState) {
                                logService.log('Verto call hangup before reaching active state... retrying call');
                                attemptReconnection();
                            }

                            break;

                        // case 'INCOMPATIBLE_DESTINATION': // deliberate fall-through
                        // case 'DESTINATION_OUT_OF_ORDER': // deliberate fall-through
                        default:
                            failedCallCount++;

                            analyticsWrapperService.eventTrack('meeting - verto - call failed due to ' + cause, {
                                category: 'verto'
                            });

                            if (failedCallCount <= 3) {
                                $timeout(attemptReconnection, 1000);

                                analyticsWrapperService.eventTrack('meeting - call failed - retrying', {
                                    category: 'banner message'
                                });
                            } else {
                                //After 3 tries
                                setPhoneOnlyState();

                                analyticsWrapperService.eventTrack('meeting - call failed - failed after 3 tries', {
                                    category: 'banner message'
                                });
                            }

                            break;
                    }
                }

                if (curState === 'new' || curState === 'requesting') {
                    //Reset for each new call
                    hangupRequested = false;
                    hangupBeforeActiveState = false;
                }

                if (curState === 'active') {
                    inCall = true;

                    connectivityService.setVertoConnected(true);

                    analyticsWrapperService.eventTrack('meeting - verto - call connected', {
                        category: 'verto'
                    });

                    if (service.getCurrentCallType() !== 'noMicNoCam') {
                        analyticsWrapperService.eventTrack('meeting - verto - call connected with media', {
                            category: 'verto'
                        });
                    } else {
                        analyticsWrapperService.eventTrack('meeting - verto - call connected with noMicNoCam', {
                            category: 'verto'
                        });
                    }

                    if (service.useEdgeServer()) {
                        logService.log('call connected to cdn server in webinar: ' + meetingService.getMeetingCode());
                    }

                    try {
                        service.setPeerConnection(d.rtc.peer.peer);
                    } catch (e) {
                        logger.error('_onDialogState', 'Unable to store ref to peerConnection', e);
                    }

                    service.initIceConnectionEventListener();

                    $timeout(function () {
                        if (inCall) {
                            try {
                                applyGetStats(peerConnection);
                            } catch (e) {
                                logService.log('Unable to apply getStats:', e);
                            }
                        }
                    }, 10000);

                    //not sure what this is doing here
                    $timeout(function () {
                        $rootScope.$broadcast('toggled-connect-overlay', { showConnectOverlay: false });
                    }, 10000);

                    var rtcLocalStream = d && d.rtc && d.rtc.localStream ? d.rtc.localStream : null;

                    var audioStream;
                    if (rtcLocalStream && rtcLocalStream.getAudioTracks) {
                        audioStream = rtcLocalStream.getAudioTracks() || [];

                        //If audioStream exists, user allowed mic permissions
                        if (audioStream && audioStream.length > 0) {
                            avDeviceService.setDevicePermissions({
                                audioAllowed: true
                            });

                            //Make sure localStreamManagerService has reference to audio track at start of a meeting...
                            //Doesn't affect any behavior, but we want to keep the references up-to-date
                            if (!localStreamManagerService.shouldUseDeprecatedSpecForStreams()) {
                                localStreamManagerService.replaceLocalAudioTrack(audioStream[0]);
                            }
                        } else {
                            avDeviceService.setDevicePermissions({
                                audioAllowed: false
                            });
                        }
                    }

                    if (rtcLocalStream && rtcLocalStream.getVideoTracks) {
                        var videoStream = rtcLocalStream.getVideoTracks() || [];

                        //If videoStream exists, user allowed webcam permissions
                        if (videoStream && videoStream.length > 0) {
                            avDeviceService.setDevicePermissions({
                                videoAllowed: true
                            });

                            if (helperService.getDevicePlatform() === 'iOS') {
                                //iOS doesn't work with replacing video video tracks
                                localStreamManagerService.currentLocalStream = rtcLocalStream;
                                localStreamManagerService.currentLocalVideoTrack = videoStream[0];
                            } else {
                                //Set up inactive stream to be used when Verto or PIP connections require a stream with an inactive video track (i.e. when vmuted)
                                //This prevents unncessary getUserMedia calls from being made
                                localStreamManagerService.initInactiveLocalVideoStreamFromClone(rtcLocalStream);

                                if (!localStreamManagerService.currentLocalStream) {
                                    localStreamManagerService.currentLocalStream = rtcLocalStream.clone();
                                }

                                //If in PIP mode, Verto should be using a cloned/inactive track
                                //while localStreamManagerService should be using a separate video track
                                if (!videoStream[0].isClone) {
                                    //We only want this called at the start of a meeting, because Verto calls getUserMedia
                                    //and creates its own video track... in this case only will we pass this track to localStreamManagerService
                                    localStreamManagerService.replaceLocalVideoTrack(videoStream[0]);
                                }
                            }
                        } else {
                            avDeviceService.setDevicePermissions({
                                videoAllowed: false
                            });
                        }
                    }

                    if (storageService.get('using-phone-for-audio')) {
                        analyticsWrapperService.eventTrack('meeting - audio mode - phone (webrtc)');
                    } else if (audioStream && audioStream.length > 0) {
                        analyticsWrapperService.eventTrack('meeting - audio mode - computer audio (webrtc)');
                    } else {
                        analyticsWrapperService.eventTrack('meeting - audio mode - no mic or phone (webrtc)');
                    }

                    if (helperService.isMobile()) {
                        service.initMobileOutput();
                    }

                    if (attendeeService.getIsHost() && meetingService.getMeetingType() === 'screenshare') {
                        logService.log('Screenshare Conf - Host Connected - Opening Screenshare Selection Screen');
                        $rootScope.$broadcast('start-screenshare');
                    }

                    //Webinar Attendees using Edge server will not receive 'fs-connection-complete' events,
                    //so we broadcast it manually based on Verto 'active' state
                    if (service.useEdgeServer()) {
                        $rootScope.$broadcast('fs-connection-complete');
                        service.startEdgeServerHeartbeat();
                    }
                }
            } else {
                //ScreenShare Calls

                if (curState === 'destroy') {
                    //if this screen share stop wasn't requested
                    if (!screenShareStopRequested) {
                        analyticsWrapperService.eventTrack('meeting - screenshare - unrequested disconnect');
                        service.forceScreenShareCleanUp();
                        service.logLastStateOfCall(connectivityService.callMediaTypes.SCREENSHARE);
                    }

                    if (cause === 'INCOMPATIBLE_DESTINATION') {
                        service.setScreenShareTCPFailed(true);
                        analyticsWrapperService.eventTrack('meeting - screenshare - incompatible destination');
                        $rootScope.$broadcast('screenshare-failed-to-start');
                    }

                    //Reset this at the end of each screenshare session
                    screenShareStopRequested = false;

                    connectivityService.resetStunTrackingData(connectivityService.callMediaTypes.SCREENSHARE);
                }

                if (curState === 'active') {
                    var screenShareLocalFeed = d.rtc.localStream;

                    if (!screenShareLocalFeed || !screenShareLocalFeed.active) {
                        //This case can happen if user clicks 'Stop sharing'
                        //from external popup before screenshare fully loads
                        logService.log('Screenshare ended before loading, forcing cleanup');
                        service.forceScreenShareCleanUp();
                        return;
                    }

                    service.initScreenShareInactiveCheck();

                    if (d.rtc && d.rtc.peer && d.rtc.peer.peer) {
                        service.applyScreenShareGetStats(d.rtc.peer.peer);
                        d.rtc.peer.peer.oniceconnectionstatechange = service.onScreenShareIceConnectionStateChange;
                    }
                }
            }
        }

        //Called when user clicks 'Stop Sharing' from external dialog window
        function onScreenShareInactive(e) {
            logService.log('onScreenShareInactive - calling forceScreenShareCleanUp');
            service.forceScreenShareCleanUp();
        }

        //Should be called when screenshare is stopped unexpectedly
        function forceScreenShareCleanUp(ignoreCancelContentInit) {
            if (!ignoreCancelContentInit) {
                //Only want to send this event if screenshare fails during content initiation
                $rootScope.$broadcast('cancel-content-initiation');
            }

            service.stopScreenShare();
            screenShareStopRequested = false;
        }

        function setScreenShareTCPFailed(newVal) {
            screenShareTCPFailed = newVal;
        }

        function _onWSLogin() {
            logService.log('Verto socket connected');

            //freeswitch socket connected
            wsLoggedIn = true;
            disconnectRetry = 0;
            socketDisconnectRequested = false;

            $rootScope.$broadcast('fs-ws-connected');
            analyticsWrapperService.eventTrack('meeting - verto - freeswitch socket connected', {
                category: 'verto'
            });
        }

        function _onWSClose() {
            if (!wsLoggedIn) {
                logService.log('Verto websocket connection attempt failed');
            } else {
                logService.log('Verto socket disconnected');
            }

            if (socketDisconnectRequested) {
                return;
            }

            var timeoutLength = 0;

            $timeout(function () {
                //disconnected. This could be from the disconnect from the freeswitch socket or timing out
                //on initial connect.
                wsLoggedIn = false;
                inCall = false;
                disconnectRetry += 1;
                if (disconnectRetry > 3) {
                    $rootScope.$broadcast('fs-ws-gave-up');
                    return;
                }
                $rootScope.$broadcast('fs-ws-disconnected', { retry: disconnectRetry });
            }, timeoutLength);

            var isPageUnloading = helperService.getIsPageUnloading();
            var isMeetingEnding = helperService.getIsMeetingEnding();
            var kmEvent;

            if (isPageUnloading || isMeetingEnding) {
                kmEvent = 'meeting - verto - freeswitch socket disconnected';
            } else {
                kmEvent = 'meeting - verto - freeswitch socket unrequested disconnected';
            }

            analyticsWrapperService.eventTrack(kmEvent, {
                category: 'verto'
            });
        }

        function _onVFITriggered(ev, data) {
            if (data && data.isScreenShare) {
                logService.log('Video Feed Interrupted received during screen share');

                analyticsWrapperService.eventTrack('meeting - screen share vfi triggered', {
                    category: 'verto'
                });
            } else {
                logService.log('Video Feed Interrupted received');

                analyticsWrapperService.eventTrack('meeting - vfi triggered', {
                    category: 'verto'
                });
            }
        }

        function onScreenShareIceConnectionStateChange() {
            var screenShareIceConnectionState;
            var screenSharePeerConnection;

            try {
                screenSharePeerConnection = service.getScreenShareCall().rtc.peer.peer;
                screenShareIceConnectionState = screenSharePeerConnection.iceConnectionState;
            } catch (e) {}

            if (screenShareIceConnectionState) {
                logService.log('ScreenShare Sender iceConnectionState:', screenShareIceConnectionState);
                analyticsWrapperService.eventTrack(
                    'Meeting - ScreenShare Sender iceConnectionState - ' + screenShareIceConnectionState,
                    {
                        category: 'verto'
                    }
                );

                if (screenShareIceConnectionState === 'failed') {
                    logService.log('ScreenShare Sender ICE Connection Failed... attempting ICE Restart');
                    service.initIceRestart('screenshare');
                }
            }
        }

        function initIceRestart(callType, includeTimeout) {
            var pc;
            var logLabel;

            if (callType === 'verto') {
                pc = peerConnection;
                logLabel = 'Verto';
            } else if (callType === 'screenshare') {
                try {
                    pc = service.getScreenShareCall().rtc.peer.peer;
                } catch (e) {}

                logLabel = 'ScreenShare Sender';
            }

            if (pc) {
                analyticsWrapperService.eventTrack('Meeting - ' + logLabel + ' - Attempting ICE Restart');

                pc.createOffer({ iceRestart: true })
                    .then(function (offer) {
                        analyticsWrapperService.eventTrack('Meeting - ' + logLabel + ' - ICE Restart Offer Received');
                        logService.log(logLabel + ' ICE Restart - Received offer... now setting local SDP');
                        pc.setLocalDescription(offer);
                    })
                    .catch(function (e) {
                        analyticsWrapperService.eventTrack('Meeting - ' + logLabel + ' - ICE Restart Error');
                        logService.log(logLabel + ' Ice Restart - Error creating offer:', e);
                    });

                //This timeout will get cancelled if ICE state reaches 'connected'
                if (includeTimeout) {
                    service.initIceRestartTimeout();
                }
            }
        }

        function initIceRestartTimeout(overrideExistingTimeout) {
            if (overrideExistingTimeout) {
                service.cancelIceRestartTimeout();
            } else if (iceRestartTimeout) {
                return;
            }

            //Currently an arbitrary number...
            //ICE Restarts usually re-connect in under 1 second,
            //So 5 seconds should be enough time to decide that we need to hangup/retry
            var iceRestartTimeoutLength = 5000;

            logService.log('Initiating Verto ICE Restart Timeout');
            iceRestartTimeout = $timeout(function () {
                iceRestartTimeout = null;

                logService.log('Verto ICE Restart timed out... hanging up and retrying Verto call');

                if (peerConnection) {
                    peerConnection.oniceconnectionstatechange = null;
                }

                service.hangup(true);
                service.attemptReconnection();
            }, iceRestartTimeoutLength);
        }

        function cancelIceRestartTimeout() {
            if (iceRestartTimeout) {
                logService.log('Cancelling Verto ICE Restart Timeout');
                $timeout.cancel(iceRestartTimeout);
                iceRestartTimeout = null;
            }
        }

        function onIceConnectionStateChange() {
            var connectionState = service.getIceConnectionState();

            logService.log('iceConnectionState: ' + connectionState);

            analyticsWrapperService.eventTrack('meeting - ice connectivity state - ' + connectionState, {
                category: 'verto'
            });

            switch (connectionState) {
                case 'new':
                    sendIceConnStateToServer('new');
                    break;
                case 'checking':
                    sendIceConnStateToServer('checking');
                    break;
                case 'failed':
                    sendIceConnStateToServer('failed');

                    iceConnectionAttempts++;

                    if (iceConnectionAttempts <= 3) {
                        $rootScope.$broadcast('toggled-connect-overlay', {
                            message: localizationService.translate('WEBINAR_STATUS_BAR.SOME_PROBLEMS'),
                            showConnectOverlay: true
                        });

                        logService.log('Verto ICE Connection Failed... attempting ICE Restart');
                        service.initIceRestart('verto', true);
                    } else {
                        //After 3 tries
                        setPhoneOnlyState();

                        analyticsWrapperService.eventTrack('meeting - ice connectivity issue - failed after 3 tries', {
                            category: 'banner message'
                        });
                    }

                    break;
                case 'disconnected':
                    //peer connection has automatic retry
                    //intentionally not sending iceConnState to server in this case
                    break;
                case 'connected':
                    sendIceConnStateToServer('connected');
                    onIceConnectionStateConnected();
                    break;
                case 'completed':
                    sendIceConnStateToServer('completed');
                    break;
                case 'closed':
                    sendIceConnStateToServer('closed');
                    break;
            }
        }

        //Private Function
        function onIceConnectionStateConnected() {
            analyticsWrapperService.eventTrack('meeting - verto - ice connection connected', {
                category: 'verto'
            });

            //iceConnectionAttempts greater than 0 implies ICE failure has happened before this connected event
            //So we also want to dismiss the disconnection banner
            if (iceConnectionAttempts > 0) {
                $rootScope.$broadcast('toggled-connect-overlay', { showConnectOverlay: false });
                iceConnectionAttempts = 0;
                service.cancelIceRestartTimeout();
            }

            service.syncRtcLocalStreamAudio();

            //TODO: change to ice connectivity event and let controllers ask service what current state is
            $rootScope.$broadcast('verto-ice-connection-completed');
        }

        function getIceConnectionState() {
            if (peerConnection && peerConnection.iceConnectionState) {
                return peerConnection.iceConnectionState;
            } else {
                return 'unassigned';
            }
        }

        function retryCall(type, user) {
            service.hangup(true);
            logService.log('Retrying call: ' + type);

            switch (type) {
                case 'audioAndVideo':
                    service.call(user);
                    break;
                case 'audioOnly':
                    service.callAudioOnly(user);
                    break;
                case 'videoOnly':
                    service.callVideoOnly(user);
                    break;
                case 'noMicNoCam':
                    service.callNoMicNoCam(user);
                    break;
                default:
                    service.call(user);
                    break;
            }
        }

        function getCurrentPlatform() {
            var platform = '';

            if (helperService.isMobile()) {
                platform = helperService.getDevicePlatform();
            } else {
                //Placeholder for now...
                //For desktop, we can return browser?
            }

            return platform.toLowerCase();
        }

        function setNeedToSubmitBandwidthResult(needToSubmit) {
            needToSubmitBandwidthResult = needToSubmit;
        }

        function initialSpeedTest() {
            var deferred = $q.defer();

            //As of iOS 10.3, speed test doesn't work due to the Websocket
            //experiencing immediate disconnections for the test...
            //
            //Skipping for now, until the Websocket issue is resolved
            if (helperService.getDevicePlatform() === 'iOS') {
                logService.log('Skipping speed test for iOS');
                bwUp = 1000;
                deferred.resolve();
                return deferred.promise;
            }

            logService.log('speedTest start');

            var speedTestTimeout = null;

            var userProvidedUploadSpeed = parseInt(helperService.getQueryParameter('uploadSpeed'));
            var userProvidedDownloadSpeed = parseInt(helperService.getQueryParameter('downloadSpeed'));

            if (userProvidedUploadSpeed > 0 || userProvidedDownloadSpeed > 0) {
                //setting invalid param to 0 and it will be ignored by freeswitch
                bwUp = isNaN(userProvidedUploadSpeed) ? 0 : userProvidedUploadSpeed;
                bwDown = isNaN(userProvidedDownloadSpeed) ? 0 : userProvidedDownloadSpeed;
                logService.log('upload: ' + bwUp + ', download: ' + bwDown);
                deferred.resolve();
                return deferred.promise;
            }

            if (!helperService.browserHasWebRTC()) {
                logger.error('initialSpeedTest', 'webrtc is not supported');
                deferred.reject('webrtc is not supported');
                return deferred.promise;
            }

            service
                .runSpeedTest()
                .then(function () {
                    if (speedTestTimeout !== null) {
                        $timeout.cancel(speedTestTimeout);
                        speedTestTimeout = null;
                    }

                    deferred.resolve();
                })
                .catch(function (err) {
                    logService.log('Speed Test error:', err);

                    //We still resolve because conferenceCtrl relies on .then() to make a call,
                    //Regardless of speedtest outcome...
                    //We should eventually use .finally instead to properly handle reject cases in that call
                    deferred.resolve();
                });

            speedTestTimeout = $timeout(function () {
                //trigger timeout after 10 seconds
                //to continue usual flow just in case for some
                //reason bandwidth test hangs
                //setting default
                bwUp = lowUploadBandwidthDefault;
                deferred.resolve();
            }, 10000);

            return deferred.promise;
        }

        function _logBandwidth(event, data) {
            logService.log('speedTest result: ' + event);
            logService.log('upDur: ' + data.upDur);
            logService.log('downDur: ' + data.downDur);
            logService.log('upKPS: ' + data.upKPS);
            logService.log('downKPS: ' + data.downKPS);

            var upRating = '';
            var downRating = '';

            if (data.upKPS > 0) {
                if (data.upKPS < 800) {
                    upRating = 'low';
                } else if (data.upKPS > 20000) {
                    upRating = 'great';
                } else {
                    upRating = 'adequate';
                }

                analyticsWrapperService.eventTrack('meeting - verto - ' + upRating + ' upload bandwidth', {
                    category: 'verto'
                });
            }

            if (data.downKPS > 0) {
                if (data.downKPS < 800) {
                    downRating = 'low';
                } else if (data.downKPS > 20000) {
                    downRating = 'great';
                } else {
                    downRating = 'adequate';
                }

                analyticsWrapperService.eventTrack('meeting - verto - ' + downRating + ' download bandwidth', {
                    category: 'verto'
                });
            }
        }

        function _onUpdateLocalAudioState() {
            if (meetingService.getIsSfuEnabled()) {
                return;
            }

            if (curCallUser) {
                curCallUser.isAudioMuted = attendeeService.getIsAudioMuted();
            }

            service.syncRtcLocalStreamAudio();
        }

        function _onUpdateLocalVideoState() {
            if (meetingService.getIsSfuEnabled()) {
                return;
            }

            if (curCallUser) {
                curCallUser.isVideoMuted = attendeeService.getIsVideoMuted();
            }

            service.syncRtcLocalStreamVideo();
        }

        function onIceServersReceived(e, newIceServers) {
            if (verto || hdScreenShareVerto) {
                helperService.removeDeprecatedIceServers(newIceServers);
                iceServers = newIceServers ? newIceServers : [];
                iceServers.unshift({ urls: 'stun:stun.l.google.com:19302' });

                logService.log('updating verto ice servers:', iceServers);

                if (verto) {
                    verto.iceServers(iceServers);
                }

                if (hdScreenShareVerto) {
                    hdScreenShareVerto.iceServers(iceServers);
                }
            } else {
                logService.log('received ice servers, but verto not instantiated yet:', iceServers);
            }
        }

        //Private function
        function applyGetStats(peer) {
            if (helperService.isChrome() || helperService.isElectron()) {
                logService.log('Starting Chrome getStats interval');

                stopGetStatsInterval();

                getStatsInterval = $interval(async function () {
                    const result = await peer.getStats();
                    service.getStatsCallback(result);
                }, 5000);
            }
        }

        function stopGetStatsInterval() {
            if (getStatsInterval) {
                $interval.cancel(getStatsInterval);
                getStatsInterval = null;
            }
        }

        //Private function
        function getStatsCallback(result) {
            if (!inCall) {
                return;
            }

            var initialPLState = connectivityService.getPacketLossState();
            var mediaType;

            for (const r of result.values()) {
                //Synchronization source (SSRC): The source of a stream of RTP packets
                if (r.type === 'ssrc' || r.ssrc) {
                    var transmissionType;

                    if (r.packetsSent) {
                        transmissionType = 'sent';
                    } else if (r.packetsReceived) {
                        transmissionType = 'received';
                    }

                    //newer versions of Chrome use r.mediaType
                    mediaType = r.kind || r.mediaType;

                    //For older versions of chrome
                    if (!mediaType && r.transportId) {
                        if (r.transportId.indexOf('audio')) {
                            mediaType = 'audio';
                        } else if (r.transportId.indexOf('video')) {
                            mediaType = 'video';
                        }
                    }

                    if (transmissionType && mediaType) {
                        connectivityService.trackPacketLoss(
                            r,
                            mediaType,
                            transmissionType,
                            connectivityService.callMediaTypes.VERTO
                        );
                    }
                }

                connectivityService.trackStunRequests(r, connectivityService.callMediaTypes.VERTO);
            }

            //TODO: If we ever refactor this, the following code can all be called from connectivityService

            var newPLState = connectivityService.getPacketLossState();

            //If PL State Changes, count gets reset to 1...
            //otherwise, increment as normal
            if (initialPLState === newPLState) {
                connectivityService.incrementPLStateCount(mediaType);
            } else {
                connectivityService.resetPLStateCountToOne(mediaType);
            }

            //Number of times PL has been in a certain state (consecutively)
            var plStateCount = connectivityService.getPLStateCount(mediaType);

            if (plStateCount === 2) {
                var ignoreState = false;

                //If first PL state calculation is "low", do not log or send state to server
                if (!firstPLStateCalculated) {
                    firstPLStateCalculated = true;
                    ignoreState = newPLState === 'low';
                }

                if (!ignoreState) {
                    logService.log('Packet Loss State changing to:', newPLState);
                    analyticsWrapperService.eventTrack('Meeting - Packet Loss State - ' + newPLState);

                    connectivityService.sendPLStateToServer(newPLState);
                }
            } else if (plStateCount > 2 && newPLState !== 'low') {
                //If PL state is medium or high, we still want to keep updating server
                //with current PL percentages (we show these stats in attendee list tooltips)
                connectivityService.sendPLStateToServer(newPLState);
            }
        }

        function applyScreenShareGetStats(peer) {
            if (helperService.isChrome()) {
                logService.log('Starting Chrome screenshare getStats interval');

                stopScreenShareGetStatsInterval();

                screenShareGetStatsInterval = $interval(async function () {
                    const result = await peer.getStats();
                    service.screenShareGetStatsCallback(result);
                }, 5000);
            }
        }

        function stopScreenShareGetStatsInterval() {
            if (screenShareGetStatsInterval) {
                $interval.cancel(screenShareGetStatsInterval);
                screenShareGetStatsInterval = null;
            }
        }

        //Private function
        function screenShareGetStatsCallback(result) {
            if (!result) {
                return;
            }

            for (const r of result.values()) {
                if (!service.isScreenShareCallConnected() || !r) {
                    return;
                }

                if (r.ssrc || r.type === 'ssrc') {
                    var transmissionType;

                    if (r.packetsSent) {
                        transmissionType = 'sent';
                    } else if (r.packetsReceived) {
                        transmissionType = 'received';
                    }

                    //newer versions of Chrome use r.mediaType
                    var mediaType = r.kind || r.mediaType;

                    //For older versions of chrome
                    if (!mediaType && r.transportId) {
                        if (r.transportId.indexOf('audio')) {
                            mediaType = 'audio';
                        } else if (r.transportId.indexOf('video')) {
                            mediaType = 'video';
                        }
                    }

                    if (transmissionType === 'sent' && mediaType === 'video') {
                        connectivityService.trackPacketLoss(
                            r,
                            mediaType,
                            transmissionType,
                            connectivityService.callMediaTypes.SCREENSHARE
                        );
                    }
                }

                connectivityService.trackStunRequests(r, connectivityService.callMediaTypes.SCREENSHARE);

                if (helperService.isChrome() && r.type === 'VideoBwe') {
                    var googAvailableSendBandwidth = 'googAvailableSendBandwidth: ' + r.googAvailableSendBandwidth;
                    var googTargetEncBitrate = 'googTargetEncBitrate: ' + r.googTargetEncBitrate;
                    var googTransmitBitrate = 'googTransmitBitrate:' + r.googTransmitBitrate;

                    logService.log(
                        'ScreenShare Stats - ' +
                            googAvailableSendBandwidth +
                            ', ' +
                            googTargetEncBitrate +
                            ', ' +
                            googTransmitBitrate
                    );
                }
            }

            if (helperService.isChrome()) {
                var newPLPercentage = connectivityService.getScreenShareStreams().sentVideo.plPercentage;
                var newPLState = connectivityService.getScreenSharePLState();

                if (newPLPercentage !== '0.00%') {
                    logService.log('ScreenShare Packet Loss:', newPLState, newPLPercentage);
                    analyticsWrapperService.eventTrack('Meeting - Screenshare - Packet Loss ' + newPLState);
                }
            }
        }

        function applyHDScreenShareConfGetStats(peer) {
            if (helperService.isChrome() || helperService.isElectron()) {
                logService.log('Starting Chrome HD ScreenShare Conference getStats interval');

                stopHDScreenShareConfGetStatsInterval();

                hdScreenShareConfgetStatsInterval = $interval(async function () {
                    const result = await peer.getStats();
                    hdScreenShareConfGetStatsCallback(result);
                }, 1000);
            }
        }

        function stopHDScreenShareConfGetStatsInterval() {
            if (hdScreenShareConfgetStatsInterval) {
                $interval.cancel(hdScreenShareConfgetStatsInterval);
                hdScreenShareConfgetStatsInterval = null;
            }
        }

        function hdScreenShareConfGetStatsCallback(result) {
            if (hdScreenShareCallStatsIntervalCount < 5) {
                hdScreenShareCallStatsIntervalCount++;
            } else {
                hdScreenShareCallStatsIntervalCount = 0;
                connectivityService.resetHDScreenSharePlisSentCounter();
            }

            for (const r of result.values()) {
                //Synchronization source (SSRC): The source of a stream of RTP packets
                if (r.type === 'ssrc' || r.ssrc) {
                    var transmissionType;

                    if (r.packetsSent) {
                        transmissionType = 'sent';
                    } else if (r.packetsReceived) {
                        transmissionType = 'received';
                    }

                    //newer versions of Chrome use r.mediaType
                    var mediaType = r.kind || r.mediaType;

                    //For older versions of chrome
                    if (!mediaType && r.transportId) {
                        if (r.transportId.indexOf('audio')) {
                            mediaType = 'audio';
                        } else if (r.transportId.indexOf('video')) {
                            mediaType = 'video';
                        }
                    }

                    if (transmissionType === 'received' && mediaType === 'video') {
                        var initialPlisSent = connectivityService.getHDScreenSharePlisSent();
                        connectivityService.setHDScreenSharePlisSent(r.googPlisSent);
                        var newPlisSent = connectivityService.getHDScreenSharePlisSent();

                        if (newPlisSent > initialPlisSent) {
                            //PlisSent increased... increment counter
                            connectivityService.incrementHDScreenSharePlisSentCounter();
                        }

                        if (hdScreenShareCallStatsIntervalCount === 5) {
                            if (connectivityService.getHDScreenSharePlisSentCounter() >= 2) {
                                //If increased at least 3 times in 5 seconds, request keyframe
                                logService.log(
                                    'HD ScreenShare PlisSent increased ' +
                                        connectivityService.getHDScreenSharePlisSentCounter() +
                                        ' times in the last 5 seconds... requesting keyframe'
                                );
                                socketService.send({ message: 'request-keyframe' });
                            }
                        }

                        connectivityService.trackPacketLoss(
                            r,
                            mediaType,
                            transmissionType,
                            connectivityService.callMediaTypes.HD_SCREENSHARE
                        );
                    }
                }
            }
        }

        //TODO: most of this function is going to be moved to the controller and call back into helper functions
        //      that send the information to the server
        function onFSConnectionComplete(e, data) {
            if (meetingService.getIsSfuEnabled()) {
                return;
            }
            //under new iosrtc, mechanism in fsrtc to attach remote stream to video element isn't happening.
            //this is a work around for that
            if (peerConnection && helperService.getDevicePlatform() === 'iOS') {
                $window.$('#videoFeed')[0].srcObject = peerConnection.getRemoteStreams()[0];
            }
            logService.log('vertoService received fs-complete-event');
            analyticsWrapperService.eventTrack('meeting - verto - FS connection complete', {
                category: 'verto',
                isCDN: service.useEdgeServer()
            });

            failedCallCount = 0;
            iceConnectionAttempts = 0;

            //send the device permissions to the node server with the extended data
            avDeviceService.sendDevicePermissions(true);

            if (needToSubmitBandwidthResult) {
                needToSubmitBandwidthResult = false;
                var bandwidthReport = {
                    message: 'attendee-bandwidth-result',
                    data: {
                        bwUp: bwUp,
                        bwDown: bwDown
                    }
                };

                socketService.send(bandwidthReport);
            }
        }

        function sendBWStateToServer(newBWState) {
            $rootScope.$broadcast('bandwidth-state-changed');

            socketService.send({
                message: 'attendee-connectivity-updated',
                data: {
                    bandwidth: newBWState
                }
            });
        }

        function attemptReconnection() {
            var bannerHeader = localizationService.translate('WEBINAR_STATUS_BAR.CONNECTIVITY_ISSUE.HEADER');
            var bannerContent = localizationService.translate('WEBINAR_STATUS_BAR.CONNECTIVITY_ISSUE.CONTENT');
            $rootScope.$broadcast('banner-message-show', { header: bannerHeader, content: bannerContent });

            service.retryCall(curCallType, curCallUser);
        }

        //Currently, clients cannot switch out of Phone Only State
        function setPhoneOnlyState() {
            connectivityService.setPhoneOnlyState();
            sendIceConnStateToServer('disconnected');
        }

        function getScreenShareCall() {
            return screenshare_call;
        }

        function isScreenShareCallConnected() {
            var call = service.getScreenShareCall();
            return call && call.state && call.state.name === 'active';
        }

        function getScreenShareResolution() {
            var screenShareStream = service.getScreenShareStream();

            var screenShareWidth = 'unknown';
            var screenShareHeight = 'unknown';

            if (screenShareStream && screenShareStream.getSettings) {
                var settings = screenShareStream.getSettings();

                if (settings) {
                    screenShareWidth = settings.width;
                    screenShareHeight = settings.height;
                }
            }

            return { width: screenShareWidth, height: screenShareHeight };
        }

        function getScreenShareType() {
            var screenShareStream = service.getScreenShareStream();
            var screenType;
            if (screenShareStream && screenShareStream.label) {
                screenType = screenShareStream.label.indexOf('window') === 0 ? 'window' : 'monitor';
            }

            return screenType;
        }

        function getScreenShareLocalFeed() {
            var call = service.getScreenShareCall();
            var localStream;

            if (call && call.rtc && call.rtc.localStream) {
                localStream = call.rtc.localStream;
            }

            return localStream;
        }

        function getScreenShareStream() {
            var feed = service.getScreenShareLocalFeed();
            var screenShareStream;

            if (feed && feed.getVideoTracks) {
                try {
                    screenShareStream = feed.getVideoTracks()[0];
                } catch (e) {
                    logService.log(e);
                }
            }

            return screenShareStream;
        }

        function initScreenShareInactiveCheck() {
            var feed = service.getScreenShareLocalFeed();

            if (feed) {
                feed.oninactive = service.onScreenShareInactive;
            }
        }

        // parse through the SDP looking for external IPs and turn servers
        // make an error log in log entries if missing
        // (this should really be warn, but I think we only have log and error)
        // if it exceptions, we'll just eat the exception and move on
        function _analyzeLogSDP(sdp) {
            var hasTurn = false;
            var hasExternal = false;

            try {
                sdp.split(/(\r\n|\r|\n)/)
                    .filter(validLine)
                    .forEach(function (line) {
                        if (line.indexOf('=candidate') > 0) {
                            var partsCandidate = line.split(' ');
                            if (partsCandidate[7] === 'relay') {
                                hasTurn = true;
                            }
                        }

                        if (line.indexOf('c=IN') >= 0) {
                            var partsIN = line.split(' ');
                            if (partsIN[1] === 'IP4') {
                                var addy = partsIN[2];

                                if (
                                    addy.indexOf('10.') != 0 &&
                                    addy.indexOf('172.16') != 0 &&
                                    addy.indexOf('192.168') != 0
                                ) {
                                    hasExternal = true;
                                }
                            }
                        }
                    });

                if (!hasTurn) {
                    logger.error('_analyzeLogSDP', 'no detected turn server');
                }

                if (!hasExternal) {
                    logger.error('_analyzeLogSDP', 'no detected external IP');
                }
            } catch (ex) {}

            loggedSDP = true;
        }

        function muteLocalOutgoingAudio() {
            var rtcLocalStream = service.getRTCLocalStream();

            if (rtcLocalStream && rtcLocalStream.getAudioTracks()[0]) {
                rtcLocalStream.getAudioTracks()[0].enabled = false;
            }
        }

        function unmuteLocalOutgoingAudio() {
            var rtcLocalStream = service.getRTCLocalStream();

            if (rtcLocalStream && rtcLocalStream.getAudioTracks()[0]) {
                rtcLocalStream.getAudioTracks()[0].enabled = true;
            }
        }

        function getCurrentCaller() {
            return curCallUser;
        }

        function setCurrentCaller(user) {
            curCallUser = user;
        }

        function setMobilePermissions(permissions) {
            mobilePermissions = permissions;
        }

        function getMobilePermissions() {
            return mobilePermissions;
        }

        function initIceConnectionEventListener() {
            var iceConnState = service.getIceConnectionState();
            logService.log('Initial iceConnectionState:', iceConnState);
            sendIceConnStateToServer(iceConnState);

            //Sometimes state already connected/completed before we attach event listener
            //So we call this to prevent the connected/completed flow from being skipped
            if (iceConnState === 'connected' || iceConnState === 'completed') {
                onIceConnectionStateConnected();
            }

            try {
                peerConnection.oniceconnectionstatechange = service.onIceConnectionStateChange;
                logService.log('onIceConnectionStateChange listener setup success');
            } catch (e) {
                logService.log('onIceConnectionStateChange listener setup failed:', e);
            }
        }

        function runSpeedTest() {
            var deferred = $q.defer();
            var socket = service.getFSSocket();

            if (socket && socket.rpcClient) {
                logService.log('Starting rpcClient.speedTest...');

                socket.rpcClient.speedTest(1024 * 128, function (ev, obj) {
                    service._logBandwidth(ev, obj);

                    var upKPS, downKPS;

                    var newBW = {
                        up: null,
                        down: null
                    };

                    try {
                        upKPS = parseInt(obj.upKPS);
                        downKPS = parseInt(obj.downKPS);
                    } catch (err) {
                        logService.log('Unable to parse bandwidth results:', err);
                    }

                    if (upKPS) {
                        bwUp = upKPS;
                        newBW.up = upKPS;
                    }

                    if (downKPS) {
                        bwDown = downKPS;
                        newBW.down = downKPS;
                    }

                    if (newBW.up || newBW.down) {
                        service.sendBWStateToServer(newBW);
                    }

                    deferred.resolve();
                });
            } else {
                deferred.reject('Cannot locate rpcClient');
            }

            return deferred.promise;
        }

        function getIceServers() {
            return iceServers;
        }

        function sendIceConnStateToServer(iceConnState) {
            var socketState;

            if (iceConnState === 'connected' || iceConnState === 'completed') {
                socketState = service.getSocketState(service.getFSSocket());
            }

            connectivityService.sendIceConnStateToServer(iceConnState, socketState);
        }

        function setPeerConnection(newPeerConnection) {
            peerConnection = newPeerConnection;
        }

        //Determines if client should call into edge server
        function useEdgeServer() {
            return service.isEdgeServerEnabled() && attendeeService.getIsAttendee();
        }

        //Determines if current meeting has edge server capabilities
        function isEdgeServerEnabled() {
            if (helperService.browserHasWebRTC() && meetingService.getMeetingType() === 'webinar') {
                return true;
            }

            return false;
        }

        function startEdgeServerHeartbeat() {
            if (!edgeServerHeartbeat) {
                logService.log('Starting edge server heartbeat');

                //Edge servers currently have idle timeout of 60 seconds
                //So we want this number to be less than that timeout length
                var heartbeatLength = 45 * 1000;

                edgeServerHeartbeat = $interval(function () {
                    try {
                        service.getVerto().message({ to: 'ping', body: 'ping' });
                    } catch (e) {
                        logService.log(e);
                    }
                }, heartbeatLength);
            }
        }

        function stopEdgeServerHeartbeat() {
            if (edgeServerHeartbeat) {
                logService.log('Stopping edge server heartbeat');
                $interval.cancel(edgeServerHeartbeat);
                edgeServerHeartbeat = null;
            }
        }

        function setOriginConfUUID(newOriginConfUUID) {
            originConfUUID = newOriginConfUUID;
        }

        function getOriginConfUUID() {
            return originConfUUID;
        }

        function setIsVertoFeedVisible(newIsVertoFeedVisible) {
            isVertoFeedVisible = newIsVertoFeedVisible;
            service.syncRtcRemoteStreamVideo();
        }

        function getIsVertoFeedVisible() {
            if (hdScreenShareFeedVisible) {
                return false;
            }

            return isVertoFeedVisible;
        }

        function isHDScreenShareAllowed() {
            //HD ScreenShare currently only enabled for
            //WebRTC browsers (non-mobile) in Meetings
            var meetingTypeWithHDScreenShare = ['meeting', 'screenshare', 'videoconference'];
            var meetingHasHDScreenShare = meetingTypeWithHDScreenShare.includes(meetingService.getMeetingType());
            return helperService.browserHasWebRTC() && meetingHasHDScreenShare && !helperService.isMobile();
        }

        function resetHDScreenShareSrc() {
            try {
                $window.$('#hdScreenShareFeed')[0].src = '';
                $window.$('#hdScreenShareFeed')[0].srcObject = null;
            } catch (err) {
                logService.log('Error resetting HD ScreenShare src:', err);
            }
        }

        function setMobileAudioOutput(outputName) {
            if (helperService.getDevicePlatform() === 'iOS') {
                if (outputName === 'speaker' || outputName === 'default') {
                    $window.cordova.plugins.audioroute.overrideOutput(outputName);
                }
            }
        }

        function setMobileAudioOutputToSpeaker() {
            setMobileAudioOutput('speaker');
        }

        // function setMobileAudioOutputToDefault () {
        //     setMobileAudioOutput('default');
        // }

        function initMobileOutput() {
            if (helperService.getDevicePlatform() === 'iOS') {
                $window.cordova.plugins.audioroute.currentOutputs(
                    function (successArg) {
                        if (successArg && successArg.length > 0 && successArg[0] === 'builtin-receiver') {
                            setMobileAudioOutputToSpeaker();
                        }
                    },
                    function (errorArg) {
                        logService.log('Error retrieving mobile audio outputs:', errorArg);
                    }
                );
            }
        }

        function cleanUpWebSocket() {
            var rpcClient;
            var socket;

            try {
                rpcClient = service.getFSSocket().rpcClient;
                socket = rpcClient._ws_socket;
            } catch (e) {}

            if (rpcClient && socket) {
                //readyState 1 means socket is open and active
                //if readyState is connecting or closed,
                if (socket.readyState !== 1) {
                    rpcClient.stopRetrying();
                }
            }
        }

        function onHangUpVerto(e, data) {
            if (service.getScreenShareCall()) {
                logService.log('onHangUpVerto - Stopping Screenshare');
                service.stopScreenShare();
            }

            service.hangup(true);

            if (data && data.closeFSSocket) {
                service.disconnectFSSocket();
            }
        }

        function onPhoneStateUpdated() {
            service.syncRtcLocalStreamAudio();
        }

        function logLastStateOfCall(callType) {
            var streamsObj;
            var label;

            switch (callType) {
                case connectivityService.callMediaTypes.VERTO:
                    streamsObj = connectivityService.getStreams();
                    label = 'Main Call';
                    break;
                case connectivityService.callMediaTypes.SCREENSHARE:
                    streamsObj = connectivityService.getScreenShareStreams();
                    label = 'ScreenShare Sender';
                    break;
                case connectivityService.callMediaTypes.HD_SCREENSHARE:
                    streamsObj = connectivityService.getHDScreenShareStreams();
                    label = 'HD ScreenShare Viewer';
                    break;
            }

            if (streamsObj) {
                logService.log(label + ' - Verto Stream Stats:', streamsObj);
            }
        }
    }
]);
